export const ROLE_VALUES = ["ADMIN", "SUPERVISOR", "OPERATOR"];

export const ROLE_OPTIONS = ROLE_VALUES.map(v => ({ value: v, label: v }));

export const normalizeRole = (r) =>
  (r ?? "").toString().trim().toUpperCase() || null;

export const isCloudtainer = (companyLabel = "") =>
  companyLabel.trim().toLowerCase() === "cloudtainer";

// Devuelve valores de rol permitidos según compañía
export function allowedRoleValuesForCompany(companyLabel) {
  return isCloudtainer(companyLabel)
    ? ["ADMIN"]
    : ["SUPERVISOR", "OPERATOR"];
}

// Devuelve opciones <Select> según compañía (lo más cómodo para el UI)
export function roleOptionsForCompany(companyLabel) {
  return allowedRoleValuesForCompany(companyLabel).map(v => ({ value: v, label: v }));
}
